module.exports = __webpack_public_path__ + "static/media/Aniwayang.98754766.png";